export const iconFontAwesomeWeatherVolcano = (
	<i className="fa-solid fa-volcano"></i>
);
